import Layout from '@/components/Layout';
import { Newspaper, Users, Award, Calendar, ArrowRight, Bell } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const BizdenHaberlerPage = () => {
  const news = [
    {
      id: 1,
      icon: Newspaper,
      category: 'Duyuru',
      date: 'Yakında',
      title: 'Yeni Hizmet Alanlarımız',
      description: 'Genişleyen hizmet ağımız ve yeni çözümlerimiz hakkında haberler yakında burada yayınlanacak. Sektörün ihtiyaçlarına yönelik geliştirdiğimiz yenilikçi hizmetlerimizi takip edin.',
      color: 'from-blue-500 to-blue-600'
    },
    {
      id: 2,
      icon: Users,
      category: 'Etkinlik',
      date: 'Yakında',
      title: 'Sektörel Etkinlikler',
      description: 'Katıldığımız fuarlar, seminerler ve iş dünyası etkinlikleri hakkında bilgiler. İnsan kaynakları sektöründeki gelişmeleri yakından takip ediyoruz.',
      color: 'from-emerald-500 to-emerald-600'
    },
    {
      id: 3,
      icon: Award,
      category: 'Başarı',
      date: 'Yakında',
      title: 'Başarı Hikayeleri',
      description: 'Müşterilerimizle birlikte elde ettiğimiz başarılar ve tamamladığımız projeler. İş ortaklarımızla gurur duyduğumuz çalışmalarımızı paylaşacağız.',
      color: 'from-purple-500 to-purple-600'
    },
    {
      id: 4,
      icon: Bell,
      category: 'Güncel',
      date: 'Yakında',
      title: 'Şirket Haberleri',
      description: 'Eta Global Group olarak büyüme hikayemiz, yeni ofislerimiz ve ekip genişlemelerimiz hakkında güncel bilgiler.',
      color: 'from-orange-500 to-orange-600'
    },
    {
      id: 5,
      icon: Users,
      category: 'Kariyer',
      date: 'Yakında',
      title: 'Kariyer Fırsatları',
      description: 'Ekibimize katılmak isteyen yetenekli profesyoneller için açık pozisyonlar ve kariyer fırsatları hakkında duyurular.',
      color: 'from-cyan-500 to-cyan-600'
    },
    {
      id: 6,
      icon: Newspaper,
      category: 'Sektör',
      date: 'Yakında',
      title: 'Sektör Analizleri',
      description: 'İnsan kaynakları sektöründeki trendler, istatistikler ve analizler. İş dünyasına dair önemli gelişmeleri sizlerle paylaşacağız.',
      color: 'from-rose-500 to-rose-600'
    }
  ];

  return (
    <Layout>
      {/* Hero Section */}
      <section className="pt-44 pb-16 bg-gradient-to-br from-slate-50 via-blue-50/30 to-white">
        <div className="eta-container">
          <div className="text-center max-w-3xl mx-auto">
            <p className="text-[#005CB2] font-semibold tracking-wider mb-3">BİZDEN HABERLER</p>
            <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Güncel Gelişmeler
            </h1>
            <p className="text-lg text-slate-600">
              Sektörel haberler, şirket duyuruları, etkinlikler ve başarı hikayelerimizi 
              bu sayfadan takip edebilirsiniz.
            </p>
          </div>
        </div>
      </section>

      {/* News Grid */}
      <section className="py-20 bg-white">
        <div className="eta-container">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {news.map((item) => (
              <article 
                key={item.id}
                className="group bg-white rounded-2xl overflow-hidden border border-slate-100 hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
              >
                <div className={`aspect-video bg-gradient-to-br ${item.color} flex items-center justify-center relative overflow-hidden`}>
                  <item.icon className="w-20 h-20 text-white/30" />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors"></div>
                </div>
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <span className="text-xs font-semibold text-[#005CB2] bg-[#005CB2]/10 px-3 py-1 rounded-full">
                      {item.category}
                    </span>
                    <div className="flex items-center gap-1 text-sm text-slate-500">
                      <Calendar className="w-4 h-4" />
                      <span>{item.date}</span>
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-[#005CB2] transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
        <div className="eta-container">
          <div className="bg-[#005CB2] rounded-3xl p-12 text-center">
            <Bell className="w-16 h-16 text-white/80 mx-auto mb-6" />
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Haberlerden Haberdar Olun
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto mb-8">
              Yeni hizmetlerimiz, sektörel gelişmeler ve kariyer fırsatları hakkında 
              bilgi almak için bizimle iletişime geçin.
            </p>
            <Link to="/iletisim">
              <Button className="bg-white text-[#005CB2] hover:bg-slate-100 gap-2">
                İletişime Geçin
                <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default BizdenHaberlerPage;
